import ApiService from "../Services/ApiService";

/**
 * P2 – Devis générés automatiquement à la déclaration.
 * Représentation renvoyée par le backend (Quote::toArray + url pré-signée).
 */
export interface QuoteInfo {
    id: number;
    quoteNumber: string;
    courseId: number | null;
    totalAmount: number;
    remainingAmount: number | null;
    status: "active" | "replaced";
    generatedAt: string | null;
    url?: string;
    /** Numéros des devis que celui-ci remplace, du plus ancien au plus récent (devis d'un cours). */
    replaces?: string[];
}

export default abstract class QuoteRepository {
    /** Devis actif d'un cours (récapitulatif post-déclaration, détail du cours). */
    public static getQuoteForCourse(courseId: number): Promise<{ quote: QuoteInfo | null }> {
        return ApiService.get(`/punctual-courses/${courseId}/quote`) as Promise<{ quote: QuoteInfo | null }>;
    }

    /** Tous les devis du professeur connecté. */
    public static getTeachrQuotes(teachrId: number): Promise<{ quotes: QuoteInfo[] }> {
        return ApiService.get(`/teachrs/v2/teachrs/${teachrId}/quotes`) as Promise<{ quotes: QuoteInfo[] }>;
    }

    /** Tous les devis du client connecté. */
    public static getClientQuotes(clientId: number): Promise<{ quotes: QuoteInfo[] }> {
        return ApiService.get(`/clients/v2/clients/${clientId}/quotes`) as Promise<{ quotes: QuoteInfo[] }>;
    }

    /** URL pré-signée fraîche (15 min) du PDF d'un devis. */
    public static download(quoteId: number): Promise<QuoteInfo & { url: string }> {
        return ApiService.get(`/quotes/${quoteId}/download`) as Promise<QuoteInfo & { url: string }>;
    }
}
